import { render, staticRenderFns } from "./CaseTypeCreateModal.vue?vue&type=template&id=432e36d0&scoped=true"
import script from "./CaseTypeCreateModal.vue?vue&type=script&lang=js"
export * from "./CaseTypeCreateModal.vue?vue&type=script&lang=js"
import style0 from "./CaseTypeCreateModal.vue?vue&type=style&index=0&id=432e36d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432e36d0",
  null
  
)

export default component.exports